<template>
    <span>
        <Cadastro-Usuarios-Adicionar-Admin></Cadastro-Usuarios-Adicionar-Admin>
    </span>
</template>

<script>
import CadastroUsuariosAdicionarAdmin from '@/components/Cadastro-Usuarios-Adicionar-Admin';

export default {
    name: 'cadusuariosaddadmin',
    components: {
        CadastroUsuariosAdicionarAdmin
    }
};
</script>